/**
 * Can this member open the primary renew dialog now?
 *
 * Only once the family has loaded (familyRoles.known), and never for a
 * household add-on: they renew through their add-on renewal, which their
 * primary's renewal sends them. Until the family is known the answer is no,
 * so an add-on never sees Renew while the page loads (production, Oct 15).
 */
export const showRenewButton = ({ renewWindowOpen, familyRoles }) =>
    !!(renewWindowOpen && familyRoles && familyRoles.known && !familyRoles.isAddOn)

export const canRenewNow = ({ renewWindowOpen, familyRoles, alreadyRenewed }) =>
    showRenewButton({ renewWindowOpen, familyRoles }) && !alreadyRenewed
